/* eslint-disable */

import { Channel } from '@/services/types'
import { Profile } from '@/store/builder/types'
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex'
@Component({
  computed: {
    ...mapGetters('builder', { stubSource: 'getProfile', stubChannelsSource: 'getChannels' }),
  },
})

class WithBuilderStubProperties extends Vue {
  stubSource!: Profile | null

  stubChannelsSource!: Channel[]

  get stubChannels() {
    return this.stubChannelsSource.map((s) => ({
      ...s,
      image: s.image ? s.image.url : null,
      highlight: null,
    }))
  }

  get stubColor(): string {
    return this.stubSource?.color ?? '#779DE9'
  }

  get stubSiteName(): string | undefined {
    return this.stubSource?.name
  }

  get stubAvatar(): string | undefined {
    return this.stubSource?.avatar?.url
  }

  get stubDescription(): string | undefined {
    return this.stubSource?.description
  }

  get stubCover() {
    return this.stubSource?.cover?.map((c) => ({ id: c.id, file: c.url })) ?? []
  }

  get stubSubscriptions() {
    return (
      this.stubSource?.subscriptions?.map((s) => ({
        id: s.id,
        name: s.name,
        price: s.price,
        duration: s.duration,
        frequency: s.frequency,
      })) ?? []
    )
  }

  get stubPosts() {
    return this.stubSource?.posts?.map((p) => ({ 
      id: p.id, 
      file: p.attachments[0]?.url,
      type: p.attachments[0]?.type ?? null,
      mime: p.attachments[0]?.mime ?? null,
    })) ?? []
  }
  
}

export default WithBuilderStubProperties
